import DragToEndOfList from './DragToEndOfList';
import EmptySpacer from './EmptySpacer';
import FolderPicker from './Folders/FolderPicker';
import FRE from './FRE';
import { QuickAdd } from 'owa-todo-views';
import RecentlyCompletedTasks from './RecentlyCompletedTasks';
import TaskCreateDroppable from './TaskCreateDroppable';
import TodoAppLink from './TodoAppLink';
import TodoContextMenu from './TodoContextMenu';
import TodoList from './TodoList';
import TodoPanelDropHint from './TodoPanelDropHint';
import { loadPanel, panelClosed } from '../actions/todoPanelStoreActions';
import { addTodo, setIsFocused, setSubject } from '../actions/quickAddActions';
import getDropState from '../selectors/getDropState';
import getSelectedFolderView from '../selectors/getSelectedFolderView';
import getSelectedFolderViewState from '../selectors/getSelectedFolderViewState';
import getQuickAddViewState from '../selectors/getQuickAddViewState';
import canCreateTaskInFolder from '../utils/canCreateTaskInFolder';
import { observer } from 'mobx-react-lite';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { ConditionalDropHint } from 'owa-drophint-views';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isTimePanelAvailable } from 'owa-time-panel-bootstrap';
import * as React from 'react';

const styles = require('./TaskListView.scss');

export default observer(function TaskListView() {
    React.useEffect(() => {
        loadPanel('TimePanel');

        return () => {
            panelClosed();
        };
    }, []);

    const folderView = getSelectedFolderView();
    const folderViewState = getSelectedFolderViewState();
    const contextMenuState = folderViewState ? folderViewState.contextMenuViewState : null;
    const canAddTasks = canCreateTaskInFolder(folderView ? folderView.folderId : null);

    const isTaskListViewDndDisabled =
        isTimePanelAvailable() && isFeatureEnabled('cal-time-panel-combinedDrop');

    let taskList = (
        <>
            <FRE />
            {canAddTasks && (
                <QuickAdd
                    uiState={getQuickAddViewState()}
                    onAddClicked={quickAddTask}
                    onSubjectChange={updateQuickAddSubject}
                    onFocus={onQuickAddFocus}
                    onBlur={onQuickAddBlur}
                />
            )}
            <div className={styles.listContent}>
                {folderView && <TodoList todoIds={folderView.activeTaskIds} />}
                {folderView && <DragToEndOfList />}
                {folderView && <RecentlyCompletedTasks />}
            </div>
            {contextMenuState && <TodoContextMenu />}
            <EmptySpacer />
        </>
    );
    if (!isTaskListViewDndDisabled) {
        taskList = (
            <ConditionalDropHint
                dropViewState={getDropState()}
                dropHintView={<TodoPanelDropHint />}
                dragItemType={DraggableItemTypes.MailListRow}>
                {taskList}
            </ConditionalDropHint>
        );
    }

    let taskListView = (
        <>
            <div className={styles.folderPickerRow}>
                <FolderPicker />
            </div>
            {taskList}
            <TodoAppLink />
        </>
    );
    if (!isTaskListViewDndDisabled) {
        /**
         * We add the droppable on the largest region possible to minimize the area where
         * we lose track of the email being dragged from the list view over to the panel.
         */
        taskListView = (
            <TaskCreateDroppable classNames={styles.container}>{taskListView}</TaskCreateDroppable>
        );
    }

    return taskListView;
});

function quickAddTask() {
    const uiState = getQuickAddViewState();

    if (uiState?.subject && uiState.subject.trim().length > 0) {
        addTodo(uiState.subject, uiState.folderId, uiState.linkedEmailEntity, uiState.extractionId);
    }
}

function updateQuickAddSubject(
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue: string
) {
    setSubject(newValue);
}

function onQuickAddFocus() {
    setIsFocused(true);
}

function onQuickAddBlur() {
    setIsFocused(false);

    // If user has typed empty spaces, placeholder won't be shown.
    // This makes the UI look really awkward. So clearn out any empty spaces.
    const uiState = getQuickAddViewState();
    if (uiState.subject.length > 0 && uiState.subject.trim().length === 0) {
        updateQuickAddSubject(null, '');
    }
}
